<script lang="ts">
    import { dev } from "$app/environment";
    import { page } from "$app/stores";
    import { test_social_share_images } from "$config";
    import { PUBLIC_PROJECT } from "$env/static/public";

    export let title: string = "title not found";
    export let description: string = "description not found...";
    export let image_title: string = title;
    export let image_sub: string = description;
    export let path: string = "";
    export let image_provided: string = "";
    export let section: string = "dead_var";
    export let image_override: string = "";

    const siteName: string = "CraftRoulette.live";
    let url_string: string = `https://craftroulette.live${path}`;

    let params: string[] = [
        `t=${encodeURIComponent(image_title ?? title)}`,
        `s=${encodeURIComponent(image_sub ?? description)}`,
        `h=${encodeURIComponent(path ?? $page.url.pathname)}`,
    ];

    if (image_override !== "") {
        params.push(`i=${encodeURIComponent(image_override)}`);
    }

    let image_url: string = `${PUBLIC_PROJECT}/api/images/social/default?${params.join("&")}`;

    console.log(image_url);

    if (image_provided !== "") {
        image_url = image_provided;
    }

    if (dev) console.log("don't mind me", section);
</script>

<svelte:head>
    <title>{title} - Craft Roulette</title>
    <meta name="robots" content="all" />
    <meta name="title" content="{title} - {siteName}" />
    <meta name="description" content={description} />

    <meta property="og:type" content="website" />
    <meta property="og:url" content={url_string} />
    <meta property="og:title" content="{title} - {siteName}" />
    <meta property="og:description" content={description} />

    <meta property="twitter:card" content="summary_large_image" />
    <meta property="twitter:url" content={url_string} />
    <meta property="twitter:title" content="{title} - {siteName}" />
    <meta property="twitter:description" content={description} />

    <meta property="twitter:image" content={image_url} />
    <meta property="og:image" content={image_url} />

    <link rel="canonical" href={url_string} />
</svelte:head>

{#if test_social_share_images && dev}
    <div class="tester">
        <img src={image_url} alt="test social share graph" />
    </div>
{/if}

<style>
.tester {
  position: fixed;
  bottom: 2rem;
  left: 2rem;
  width: 600px;
  height: auto;
  z-index: 1000;
}
.tester img {
  width: 100%;
  height: auto;
  border: 1px solid #333;
  border-radius: 5px;
}
</style>
